import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import LeadListCard from "../../../clientAdmin/components/lead/leadList/LeadListCard";
import { Box, Grid, Typography } from "@mui/material";
const CustomerLeadList = ({ setGenerateId }: any) => {
  const { customerLeads } = useSelector((state: any) => state.customer);
  const [selectedLead, setSelectedLead] = useState<string | null>(null);

  // Set first lead as selected by default when leads are loaded
  useEffect(() => {
    if (customerLeads && customerLeads.length > 0 && !selectedLead) {
      const firstLeadId = customerLeads[0]?.generateId || customerLeads[0]?.generated_id;
      setSelectedLead(firstLeadId);
      setGenerateId(firstLeadId);
    }
  }, [customerLeads, selectedLead, setGenerateId]);
  return (
    <>
      <Box
        sx={{
          // maxWidth: 360,
          // margin: "auto",
          // background: "#fff",
          flexDirection: "column",
          // borderRadius: "5px",
        }}
      >
        <Box sx={{ width: "100%", paddingBottom: 4, paddingTop: 1 }}>
          <Grid
            container
            spacing={0}
            alignItems="center"
            sx={{
              background: "#E5F4F1",
              color: "#637381",
              padding: "10px 10px",
              // borderTopLeftRadius: "10px",
              // borderTopRightRadius: "10px",
              marginBottom: "4px",
              border: "1px solid #C4CDD5",
            }}
          >
            <Grid item xs={6} sx={{ borderRight: "1px solid #C4CDD5" }}>
              <Typography variant="body2" fontWeight={600}>
                Customer List
              </Typography>
            </Grid>
            <Grid
              item
              xs
              sx={{
                textAlign: "center",
                borderRight: "1px solid #C4CDD5",
              }}
            >
              <Typography variant="body2" fontWeight={600}>
                F
              </Typography>
            </Grid>
            <Grid
              item
              xs
              sx={{
                textAlign: "center",
                borderRight: "1px solid #C4CDD5",
              }}
            >
              <Typography variant="body2" fontWeight={600}>
                A
              </Typography>
            </Grid>
            <Grid
              item
              xs
              sx={{
                textAlign: "center",
                borderRight: "1px solid #C4CDD5",
              }}
            >
              <Typography variant="body2" fontWeight={600}>
                M
              </Typography>
            </Grid>
            <Grid item xs sx={{ textAlign: "center" }}>
              <Typography variant="body2" fontWeight={600}>
                L
              </Typography>
            </Grid>
          </Grid>
          {customerLeads &&
            customerLeads?.map((lead: any, index: number) => (
              <LeadListCard
                key={lead?.generated_id || lead?.generateId || index}
                value={"0"}
                lead={lead}
                selectedLead={selectedLead}
                setGenerateId={setGenerateId}
                setSelectedLead={setSelectedLead}
              />
            ))}
        </Box>
      </Box>
    </>
  );
};
export default CustomerLeadList;
